/****************************************************
 * Module Name:  addCutpolsymModal.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import React, { Component } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CutpolsymProxy from "../../utility/proxy/manager/cutpolsymProxy";
import Constants from "../../utility/constants";
import CircularProgress from "@mui/material/CircularProgress";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

export default class AddCutpolsymModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newcutpolsym: this.props.editOperation ? this.props.sourceData.name : "",
      newcutpolsymfullname: this.props.editOperation
        ? this.props.sourceData.fullname
        : "",
      newdescription: this.props.editOperation
        ? this.props.sourceData.description
        : "",

      showError: false,

      validateCutpolsymPresentSpinner: false,
      showValidationMessage: false,
      cutpolsymAvailable: true,

      cutpolsymValidationError: "",
      fullNameValidationError: "",
    };
  }

  handleSave = () => {
    let data = {
      id: this.props.editOperation ? this.props.sourceData.id : undefined,
      name: this.state.newcutpolsym,
      fullname: this.state.newcutpolsymfullname,
      description: this.state.newdescription,
    };

    if (this.props.handleSave) {
      if (this.props.handleValidation) {
        if (this.props.handleValidation(data)) this.props.handleSave(data);
        else
          this.setState({
            showError: true,
          });
      } else this.props.handleSave(data);
    }
  };

  closeErrorDialog = () => {
    this.setState({
      showError: false,
    });
  };

  validateCutpolsymPresent = (cutpolsymEntered) => {
    if (!cutpolsymEntered || cutpolsymEntered.trim() === "") return;

    this.setState({
      validateCutpolsymPresentSpinner: true,
    });

    CutpolsymProxy.CheckCutpolsymAvailable(cutpolsymEntered, (response) => {
      //if we got response that means cutpolsym is present at backend
      if (response) {
        //CutpolsymName already present
        this.setState({
          validateCutpolsymPresentSpinner: false,
          showValidationMessage: true,
          cutpolsymAvailable: false,
        });
      } else {
        //CutpolsymName not available, so can be used
        this.setState({
          validateCutpolsymPresentSpinner: false,
          showValidationMessage: true,
          cutpolsymAvailable: true,
        });
      }
    });
  };

  buttonDisable = () => {
    if (
      this.props.editOperation &&
      this.state.newcutpolsymfullname.length === 0
    )
      return true;

    if (!this.props.editOperation)
      return (
        !this.state.showValidationMessage ||
        !this.state.cutpolsymAvailable ||
        this.state.newcutpolsymfullname.length === 0
      );

    return false;
  };

  render() {
    return (
      <Box>
        <CommonSnackbar
          show={this.state.showError}
          message={
            <Box>
              Add cutpolsym validation Failed
              <br /> Please enter complete data
            </Box>
          }
          variant={"error"}
          autoHide={false}
          handleClose={this.closeErrorDialog}
          title="Validation Failure"
        />

        <Modal backdrop="static" show={this.props.Show} onHide={this.props.handleClose} enforceFocus={false}>
          <Modal.Header closeButton>
            <Modal.Title>
              <img
                src={logo}
                height="40pt"
                width="40pt"
                alt={Constants.COMPANY_SITE}
              />
              &nbsp;&nbsp;
              {this.props.editOperation
                ? "Edit Cutpolsym"
                : "Add New Cutpolsym"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <center>
              <table style={{ width: "100%" }}>
                <tbody>
                  {this.props.editOperation && (
                    <tr>
                      <td>
                        <Form.Label>Cutpolsym Id</Form.Label>
                      </td>
                      <td>
                        <Form.Label>{this.props.sourceData.id}</Form.Label>
                      </td>
                    </tr>
                  )}
                  {this.props.editOperation && (
                    <tr>
                      <td>&nbsp;</td>
                    </tr>
                  )}
                  <tr>
                    <td>
                      <Form.Label>
                        Cutpolsym <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    {this.props.editOperation ? (
                      <td>
                        <Form.Label>{this.state.newcutpolsym}</Form.Label>
                      </td>
                    ) : (
                      <td>
                        <TextField
                          margin="normal"
                          fullWidth
                          size="small"
                          label="Cutpolsym (required)"
                          placeholder="Enter Cutpolsym"
                          value={this.state.newcutpolsym}
                          autoFocus
                          onBlur={(e) =>
                            this.validateCutpolsymPresent(
                              this.state.newcutpolsym
                            )
                          }
                          onChange={(e) =>
                            this.setState({
                              newcutpolsym: e.target.value,
                              showValidationMessage: false,
                              cutpolsymValidationError: Utility.CheckIsPresent(
                                e.target.value
                              )
                                ? ""
                                : "Cutpolsym Cannot be Empty",
                            })
                          }
                          helperText={this.state.cutpolsymValidationError}
                          error={this.state.cutpolsymValidationError.length > 0}
                        />
                      </td>
                    )}
                  </tr>
                  <tr>
                    <td></td>
                    <td>
                      {this.state.validateCutpolsymPresentSpinner ? (
                        <CircularProgress size="1rem" />
                      ) : !this.state.showValidationMessage ? (
                        <Box>&nbsp;</Box>
                      ) : this.state.cutpolsymAvailable ? (
                        <font color="green">Cutpolsym available</font>
                      ) : (
                        <font color="red">Cutpolsym not available</font>
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>
                        Cutpolsym Fullname <sup style={{ color: "red" }}>*</sup>
                      </Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Cutpolsym Fullname (required)"
                        placeholder="Enter Cutpolsym Fullname"
                        value={this.state.newcutpolsymfullname}
                        onChange={(e) =>
                          this.setState({
                            newcutpolsymfullname: e.target.value,
                            fullNameValidationError: Utility.CheckIsPresent(
                              e.target.value
                            )
                              ? ""
                              : "Cutpolsym Fullname Cannot be Empty",
                          })
                        }
                        helperText={this.state.fullNameValidationError}
                        error={this.state.fullNameValidationError.length > 0}
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Form.Label>Description</Form.Label>
                    </td>
                    <td>
                      <TextField
                        margin="normal"
                        fullWidth
                        size="small"
                        label="Description"
                        placeholder="Enter Description"
                        value={this.state.newdescription}
                        onChange={(e) =>
                          this.setState({ newdescription: e.target.value })
                        }
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </center>
          </Modal.Body>
          <Modal.Footer>
            <LoadingButton
              loading={this.props.loading}
              loadingPosition="start"
              startIcon={<SaveIcon />}
              variant="contained"
              onClick={() => this.handleSave()}
              disabled={this.buttonDisable()}
              sx={{ mr: 1 }}
            >
              Save
            </LoadingButton>
            <Button
              variant="contained"
              color="error"
              onClick={this.props.handleClose}
              disabled={this.props.loading}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </Box>
    );
  }
}
